// Most of these modules depend on the google maps global variable `google`.
// Don't load this pack unless the google maps script is loaded further up
// the page.


import {searchResults} from 'src/search_results/search_results';



window.addEventListener('DOMContentLoaded', (e) => {

  if(document.querySelector('#searchResultsListColumn')){
    searchResults.init();
  }

});
